import axios from "axios";

export const axiosInstance = axios;


/**
 * Specifies the fields for the signup page
 */
export const loginFields = [
  { name: "email", label: "Email Address", type: "email" },
  { name: "password", label: "Password", type: "password" },
  { name: "confirmPassword", label: "Confirm Password", type: "password" }
];

/**
 * Specifies the fields for add store
 */

export type LoginDetails = {
  email: string;
  password: string;
  confirmPassword: string;
};
export const storeInfo = [
  { name: "store_name", label: "Store Name", required: true, type: "text" },
  { name: "store_owner", label: "Store Owner", required: true, type: "text" },
  { name: "email", label: "Email Address", required: false, type: "email", },
  { name: "phone_no", label: "Phone No", required: true, type: "tel" },
  { name: "city", label: "City", required: true, type: "text" },
  { name: "address", label: "Address", required: true, type: "text" },
  { name: "state", label: "State", required: true, type: "text" },
  { name: "password", label: "Password", required: true, type: "password" },
];

export type StoreInfo = {
  store_name: string;
  store_owner: string;
  phone_no: string;
  email: string;
  address: string;
  state: string;
  city: string;
  password: string;
};

/**
 * Approved categories sold in a store
 */
export const productCategory: string[] = [
  "Soap",
  "Indomie",
  "Maggi",
  "Mama gold"
];

/**
 * Add product info
 */
export const productInfo = [
  { name: "name", label: "Product Name", required: true,  },
  { name: "brand", label: "Product Brand", required: true,  },
  { name: "category", label: "Product Category", required: true,  },
  { name: "price", label: "Product Price", required: false, },
];



export type ProductType = {
  name: string;
  brand: string;
  category: string;
  price: string;
};

export type Message = {
  type: any;
  msg: string;
};

/**
 * Adds products to the localStorage if the user is offline
 */
export const storeDataLocally = (values, key, token) => {
  const storedData = {
    ...values,
    token
  }
  if(localStorage.getItem(key)){
    const prev = JSON.parse(localStorage.getItem(key));
    prev.push(storedData);
    window.localStorage.setItem(key, JSON.stringify(prev));
  }else{
    const data = [];
    data.push(storedData);
    window.localStorage.setItem(key, JSON.stringify(data));
  }
};

/**
 * Adds store to the localStorage if the user is offline
 */
export const saveStoreToLocalStorage = (values, key) => {
  if(localStorage.getItem(key)){
    const prev = JSON.parse(localStorage.getItem(key));
    prev.push(values);
    window.localStorage.setItem(key, JSON.stringify(prev));
  }else{
    const data = [];
    data.push(values);
    window.localStorage.setItem(key, JSON.stringify(data));
  }
};

/**
 * URL to add products
 */
export const ADD_PRODUCT_URL = "https://betastore-staging.herokuapp.com/api/v1/products";
/**
 * URL for client lead generation
 */
export const ADD_STORE_URL = "https://betastore-staging.herokuapp.com/api/v1/clients";

/**
 * Local storage keys
 */
export const localStorageKeys = {
  product: 'products',
  store: 'stores'
}

/**
 * Checkes if the user is online and there's a product in the local storage
 * then sends it to the server
 */
export const checkLocalData = (url, key) => {
  if(localStorage.getItem(key)){
    const data = JSON.parse(localStorage.getItem(key))
    try {
      data.map((item) => {
        const token = item.token;
        delete item.token
        axios.
        post(url, item, {
        headers: { 
        'Authorization': `Bearer ${token}`,
      }})
          .then(() => console.log(`${key} sent to the server successfully`))
          .catch(e => console.log("error: ", e))
     })
      localStorage.removeItem(key)
    }catch (e) {
      console.log(`Error sending ${key} to server`, e)
    }
  }
}

export const saveLocalComments = () => {
  if(localStorage.getItem("comment")){
    const data = JSON.parse(localStorage.getItem("comment"))
    try {
      data.map((item) => {
        axios.
        post(item.url, item.msg, {
         headers: { 
        'Authorization': `Bearer ${item.token}`,
      }})
          .then(() => console.log(`comments sent to the server successfully`))
          .catch(e => console.log("error: ", e))
     })
      localStorage.removeItem("comment")
   }catch (e) {
      console.log(`Error sending comments to server`, e)
    }
  }
}

export const saveLocalSignUpData = (url, key) => {
  if(localStorage.getItem(key)){
    const data = JSON.parse(localStorage.getItem(key))
    try {
      data.map((item) => {
        axios.
        post(url, item,)
          .then(() => console.log(`${key} sent to the server successfully`))
          .catch(e => console.log("error: ", e))
     })
      localStorage.removeItem(key)
    }catch (e) {
      console.log(`Error sending ${key} to server`, e)
    }
  }
}